import React, { useState } from "react";
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
    Snackbar,
    Alert,
} from "@mui/material";
import axios from "axios";

const AddCreditForm = () => {
    const [credit, setCredit] = useState("");
    const [remark, setRemark] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleAddCredit = async () => {
        if (!credit || isNaN(Number(credit))) {
            setSnackbar({
                open: true,
                message: "Enter a valid credit amount.",
                severity: "error",
            });
            return;
        }

        try {
            const storedUser = localStorage.getItem("user");
            const parsedUser = storedUser ? JSON.parse(storedUser) : null;
            const currentUsername = parsedUser?.username || parsedUser?.email || "";

            const payload = {
                remark: remark?.trim() || null,
                transaction_user: currentUsername, // acting user
                type: "whatsapp_balance",     // balance type
                username: currentUsername,         // user receiving credit
                whatsapp_balance: Number(credit),
            };

            const response = await axios.post(
                "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/add_credit",
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (response.status === 200) {
                setSnackbar({
                    open: true,
                    message: "Credit added successfully!",
                    severity: "success",
                });
                setCredit("");
                setRemark("");
            } else {
                setSnackbar({
                    open: true,
                    message: "Unexpected server response.",
                    severity: "warning",
                });
            }
        } catch (error) {
            console.error("Add credit failed:", error);
            setSnackbar({
                open: true,
                message: "Failed to add credit.",
                severity: "error",
            });
        }
    };

    return (
        <Box mt={4} p={3} bgcolor="#f0f4ff" borderRadius={2}>
            <Typography variant="h6" fontWeight="bold" mb={2}>
                Add Credit
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        fullWidth
                        label="Credit Amount"
                        value={credit}
                        onChange={(e) => setCredit(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="Remark"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={2}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleAddCredit}
                        sx={{ height: "100%" }}
                    >
                        Add Credit
                    </Button>
                </Grid>
            </Grid>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default AddCreditForm;
